(function(root) {
  'use strict';
  function fit(naturalWidth,naturalHeight,stageWidth,stageHeight) {
    const ratio = Math.min(stageWidth * .96 / naturalWidth, stageHeight * .96 / naturalHeight);
    return {width:naturalWidth * ratio,height:naturalHeight * ratio};
  }
  function clampState(state,box) {
    const scale = Math.max(1,Math.min(4,Number(state.scale) || 1));
    const maxX = Math.max(0,(box.width * scale - box.stageWidth) / 2);
    const maxY = Math.max(0,(box.height * scale - box.stageHeight) / 2);
    return {scale,x:Math.max(-maxX,Math.min(maxX,state.x || 0)),y:Math.max(-maxY,Math.min(maxY,state.y || 0))};
  }
  function zoomAt(state,newScale,point,box) {
    const scale = Math.max(1,Math.min(4,newScale));
    const ratio = scale / state.scale;
    return clampState({scale,x:point.x-(point.x-state.x)*ratio,y:point.y-(point.y-state.y)*ratio},box);
  }
  root.CalmaZoom = Object.freeze({fit,clampState,zoomAt});
  if (typeof module !== 'undefined') module.exports = root.CalmaZoom;
})(typeof window !== 'undefined' ? window : globalThis);
